//================================================================
//  Page: 404 - Not Found Page 
//================================================================

//  Purpose: If no route for this page is found

//  Supporting documentation
//    - https://stackoverflow.com/questions/70524739/react-router-dom-v6-doesnt-redirect-to-not-found

//================================================================

//Libraries
import React from 'react';
import { Link } from "react-router-dom";

//Images
import PageNotFound from '../../Components/Images/Splash/Error_Not_Found.svg'

export default function NotFound() {
  
  //------------------------------------------------------
  //  Returned HTML
  //------------------------------------------------------

    return (
      <div className='px-[15%] py-[10%] text-center h-[fit-content] [overflow-anchor:none] flex flex-col items-center'>

        <img src={PageNotFound} height={150} width={150} alt='Page Not Found'></img>

        {/* Title */}
        <p className='text-2xl font-light pt-4'><b>404 - Page not found.</b> </p>
        <p className='text-base'>We’re sorry, the page you’re looking for doesn’t exist.</p>

        <Link to="/">
          <button className='Primary-Button'> Return Home </button>
        </Link>  

      </div>
    )

  //------------------------------------------------------
}
